import useFindRouteByPath from 'src/hooks/useRouteToMetaData.hook'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body2_b14,
  Noto_body3_b12,
  Noto_body3_r12,
  Noto_desc_r10,
} from 'src/styles/fonts/NotoSansKrFonts'
import styled, { css } from 'styled-components'
import usePageNav from 'src/hooks/usePageNav.hook'
import { Bridge } from 'src/utils/bridge'
import { useLocation } from 'react-router-dom'

const Footer = () => {
  const { isFooter } = useFindRouteByPath()
  const { serviceTermsPageNav, privacyPolicyPageNav } = usePageNav()
  const { pathname } = useLocation()

  const isGiftcard = pathname.includes('/giftcard')
  const isPreviewPage = pathname.includes('/preview')

  const handleServiceTermsPageNav = () => {
    if (isPreviewPage) {
      window.open('https://www.couponwallet.co.kr/terms/Service', '_blank')
    } else {
      serviceTermsPageNav()
    }
  }

  const handlePrivacyPolicyPageNav = () => {
    if (isPreviewPage) {
      window.open('https://www.couponwallet.co.kr/terms/PrivacyPolicy', '_blank')
    } else {
      privacyPolicyPageNav()
    }
  }

  if (!isFooter && !isGiftcard) {
    return null
  }

  return (
    <S.FooterContainer>
      <Typography $fontStyle={Noto_body2_b14} $color={'var(--black-40)'}>
        휴대폰쿠폰지갑
      </Typography>
      <S.FooterNavBox>
        <Typography
          $style={S.FooterLink('default')}
          onClick={() => Bridge.handleReqExternalOpenUrl('http://www.datauniverse.co.kr/')}
        >
          회사소개
        </Typography>
        <S.FooterNavDivider />
        <Typography $style={S.FooterLink('default')} onClick={handleServiceTermsPageNav}>
          이용약관
        </Typography>
        <S.FooterNavDivider />
        <Typography $style={S.FooterLink('bold')} onClick={handlePrivacyPolicyPageNav}>
          개인정보처리방침
        </Typography>
      </S.FooterNavBox>
      <Container $option="flex_column" $row_gap="20px">
        <Typography $fontStyle={Noto_desc_r10} $color="var(--black-30)">
          (주)데이터유니버스는 통신판매 당사자가 아닌 통신판매 중개자로서 입점 판매자가 판매하는
          상품의 정보, 거래 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.
        </Typography>
        <Typography $fontStyle={Noto_desc_r10} $color="var(--black-40)">
          (주)데이터유니버스 <br /> 대표자 강원석 | 주소 : 서울특별시 영등포구 여의대로 70 원센티널
          10층 | 사업자 등록번호 382-86-01230 | 통신판매업신고 : 제2020-서울영등포-1315호 | 고객센터
          : 1855-4531 (09:00 ~ 12:00 / 13:00 ~ 18:00, 공휴일 휴무) | 이메일 : cs_coupon@datau.co.kr
        </Typography>
        <Typography $fontStyle={Noto_desc_r10} $color="var(--black-40)">
          ⓒ 2024 DATAUNIVERSE All rights reserved.
        </Typography>
      </Container>
    </S.FooterContainer>
  )
}
export default Footer

const S = {
  FooterContainer: styled.footer`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 40px 20px 120px 20px;
    background-color: var(--black-4);
    z-index: 1;
  `,
  FooterLink: (option: 'bold' | 'default') => css`
    cursor: pointer;
    color: var(--black-40);
    ${option === 'bold' ? Noto_body3_b12 : Noto_body3_r12}
  `,
  FooterNavBox: styled.div`
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    gap: 8px;
  `,
  FooterNavDivider: styled.span`
    width: 1px;
    height: 10px;
    border-right: 1px solid var(--black-40);
  `,
}
